import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { AuthService } from "src/app/providers/auth.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { AddCustomerComponent } from "src/app/shared/components/add-customer/add-customer.component";
import { CreateInvoiceForCustomersComponent } from "src/app/shared/components/create-invoice-for-customers/create-invoice-for-customers.component";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { PaymentIntimationComponent } from "src/app/shared/components/payment-intimation/payment-intimation.component";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";

@Component({
  selector: "sm-customer-details",
  templateUrl: "./customer-details.component.html",
  styleUrls: ["./customer-details.component.scss"],
})
export class CustomerDetailsComponent implements OnInit, OnDestroy {
  discountInfo: any = null;

  loader: boolean = false;
  apisuib: Subscription;
  customerData: any = [];
  constructor(
    private navservice: NavigationService,
    private route: ActivatedRoute,
    private ls: LoaderServiceService,
    private apiservice: ApiService,
    private authService: AuthService,
    private _modelRef: MatDialog,
    private router: Router,
  ) {
    this.navservice.hideSidebarAndNav = false;

    this.apisuib = this.apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_GET_CUSTOMER_DETAILS
      ) {
        this.customerData = [];
        if (resdata.result) {
          resdata.result.total_wallet =
            typeof resdata.result.total_wallet == "string"
              ? JSON.parse(resdata.result.total_wallet)
              : resdata.result.total_wallet;

          this.customerData.push(resdata.result);
          this.customerData.forEach((element: any) => {
            if (element.gender == 1) {
              element.gender1 = "Male";
            } else if (element.gender == 2) {
              element.gender1 = "Female";
            } else if (element.gender == 3) {
              element.gender1 = "Others";
            } else if (!element.gender || element.gender == "null") {
              element.gender1 = "---";
            }
          });
        }
            sessionStorage.setItem("mefrp", this.customerData[0].email);

        this.apiservice.getBillDiscountData(
          localStorage.getItem(
            SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
          ),
        );
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_DISCOUNT
      ) {
        this.discountInfo = null;
        if (resdata.result) {
          this.discountInfo = resdata.result;
        }
        this.ls.showLoader = false;
        this.loader = false;
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_ENTITY_CUSTOMER_DATA
      ) {
        if (resdata.result) {
          this.router.navigate(["../"], {
            relativeTo: this.route,
            queryParamsHandling: "preserve",
          });
        }
      }
    });
  }
  entityHash: any;
  countryCode: any;
  phone: any;
  name: any;
  isOwner: boolean = false;

  isAccessForEmployeeInvoice: boolean = false;
  isEntityIndividual: any;

  ngOnInit(): void {
    this.ls.showLoader = true;
    this.loader = true;
    this.isOwner = this.authService.isOwner();
    this.isEntityIndividual = sessionStorage.getItem("isEntityIndividual");

    if (this.isOwner) {
      this.isAccessForEmployeeInvoice = true;
    } else {
      const ssa = sessionStorage.getItem(
        SM_CONSTANTS.EMPLOYEE_SHOP_SERVICE_INVOICE_ACCESS,
      );
      const hsa = sessionStorage.getItem(
        SM_CONSTANTS.EMPLOYEE_HOME_SERVICE_INVOICE_ACCESS,
      );
      const vsa = sessionStorage.getItem(
        SM_CONSTANTS.EMPLOYEE_VIRTUAL_SERVICE_INVOICE_ACCESS,
      );

      const bsss = sessionStorage.getItem("shop_service_status");
      const bhss = sessionStorage.getItem("home_service_status");
      const bvss = sessionStorage.getItem("virtual_service_status");

      // sessionStorage.getItem() returns a string or null.

      // 2. Check if ANY of the retrieved values is the string '1'
      if (
        (ssa == "1" && bsss == "1") ||
        (hsa == "1" && bhss != "2") ||
        (vsa == "1" && bvss != "2")
      ) {
        this.isAccessForEmployeeInvoice = true;
      }
    }
    this.route.queryParams.subscribe((data) => {
      if (data) {
        this.entityHash = data.entityHash;
        this.countryCode = data.countryCode;
        this.phone = data.phone;
        this.name = data.name;
      }
    });

    this.apiservice.getCustomerDetails(
      this.entityHash,
      this.countryCode,
      this.phone,
      this.name,
    );
  }

  ngOnDestroy(): void {
    this.apisuib.unsubscribe();
  }

  createInvoice(customer: any) {
    let data = {
      entityHash: this.entityHash,
      eph: localStorage.getItem(
        SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
      ),
      customer: customer,
      discountInfo: this.discountInfo,
    };
    // this._modelRef.open(AddNewBookingComponent, {
    //   width: '700px',
    //   data: {
    //     title: 'New Booking',
    //     ref: this._modelRef,
    //     data: data
    //   },
    // });
    this._modelRef.open(CreateInvoiceForCustomersComponent, {
      width: "700px",
      data: {
        title: "New Invoice",
        ref: this._modelRef,
        data: data,
      },
    });
  }

  openAllBookings(item: any) {
    console.log(item);
    sessionStorage.setItem("cusphoneforbill", item.country_code);
    this.router.navigate(
      ["all-bookings"],
      {
        relativeTo: this.route,
        queryParamsHandling: "merge",
        queryParams: { phone: item.phone, mn: item.name },
      },
    );
  }
  openAllPayments(item: any) {
    console.log(item);
    sessionStorage.setItem("cusphoneforbill", item.country_code);
    this.router.navigate(
      ["all-payments"],
      {
                relativeTo: this.route,

        queryParamsHandling: "merge",
        queryParams: {
          phone: item.phone,
          code: item.country_code,
          mn: item.name,
        },
      },
    );
  }

  openwallemoney(item: any) {
    sessionStorage.setItem("cusphoneforbill", item.country_code);
    this.router.navigate(
      ["customer-wallet-money"],
      {
                relativeTo: this.route,

        queryParamsHandling: "merge",
        queryParams: {
          phone: item.phone,
          code: item.country_code,
          mn: item.name,
          memail: item.email,
        },
      },
    );
  }
  openDueBookings(item: any) {
    sessionStorage.setItem("cusphoneforbill", item.country_code);
    this.router.navigate(["due-bookings"], {
      relativeTo: this.route,
      queryParamsHandling: "merge",
      queryParams: { phone: item.phone, mn: item.name },
    });
  }
  openPaymentIntimation(item: any) {
    this._modelRef.open(PaymentIntimationComponent, {
      width: "700px",
      data: {
        title: "Payment Intimation",
        ref: this._modelRef,
        data: item,
        type: 1,
        entity_hash: this.entityHash
      },
    });
  }

  openrewardpoint(item: any) {
    // this.router.navigate(["/businesses","details","customers","reward-points"
    // ],{queryParamsHandling: 'preserve'});

    sessionStorage.setItem("cusphoneforbill", item.country_code);
    this.router.navigate(["reward-points"], {
      relativeTo: this.route,
      queryParamsHandling: "merge",
      queryParams: {
        phone: item.phone,
        code: item.country_code,
        mn: item.name,
        memail: item.email,
      },
    });
  }

  deleteCustomer(item: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Are you sure you want to delete this customer?",
        okbtn: "Yes",
        cancelbtn: "No",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let obj = {
          customerHash: item.hash_id,
          entityHash: this.entityHash,
        };

        this.ls.showLoader = true;
        this.apiservice.deleteEntityCustomer(obj);
      }
    });
  }

  editCustomer(rowvalue: any) {
    let dialogref = this._modelRef.open(AddCustomerComponent, {
      width: "500px",
      disableClose: true,
      data: {
        customerData: rowvalue,
        entityHash: this.entityHash,
        eph: localStorage.getItem(
          SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
        ),
        link: "",
        title: "Edit customer",
      },
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        if (res[0].errorcode == 1) {
          const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
            width: "500px",
            data: {
              title: "Alert",
              message:
                "There's another customer with the same name and phone number exists. If you really want to create one, change the name or phone number.",
              okbtn: "Ok",
              cancelbtn: "Cancel",
              type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
            },
            disableClose: true,
          });
        } else {
          this.ls.showLoader = true;
          this.apiservice.getCustomerDetails(
            this.entityHash,
            this.countryCode,
            this.phone,
            this.name,
          );
        }
      }
    });
  }
}
